import { getBaseUrl } from "../../utils/getBaseUrl";
import { getCountryUrlPrefix } from "../../utils/getCountryUrlPrefix";

export default class AlgonomyTracking {
  static trackClickOnRecommendation(
    clickTrackingInfo: string,
    countryUrlPrefix: string,
  ): void {
    const blob = new Blob([clickTrackingInfo], { type: "application/json" });
    const url = new URL(
      `${getCountryUrlPrefix(countryUrlPrefix)}/reco/recommendations-frontend/click`,
      getBaseUrl(countryUrlPrefix),
    );
    window.navigator.sendBeacon(url, blob);
  }
}
